// extracted by mini-css-extract-plugin
export default {"LoaderWrapper":"Loader_LoaderWrapper__X+1wU"};